import axios from 'axios'
import moment from 'moment'
export default async () => {

  const steps = [
    'fetch team',
    '(remove reports from users)',
    'remove users from team',
  ]

  console.log('Cleanup started')

  console.log('Step 1 - fetching mock team')
  const mockTeam = (await axios.get('https://timenow-api-dev.geshdo.com/admin/teams')).data
    .find(team => team.name === 'Avengers')

  if (!mockTeam) return console.log('no mockteam, stopping')

  console.log('Step 2 - fetching mock team members')
  const teamMembers = (await axios.get(`https://timenow-api-dev.geshdo.com/admin/teams/${mockTeam.id}/members`)).data
  console.log(teamMembers);

  console.log('Step 3 - remove all reports from users')
  const from = moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD')
  const to = moment().add(3, 'months').startOf('month').format('YYYY-MM-DD')
  await Promise.all(
    teamMembers.map(async (member) => {
      const allReports = (await axios({
        url: `https://timenow-api-dev.geshdo.com/reports?from=${from}T00:00:00Z&to=${to}T23:59:59Z`,
        method: 'GET',
        headers: {
          "userId": member.userId
        }
      })).data
      console.log(allReports);

      await Promise.all(
        allReports.map(async (report) => {
          try {
            await axios({
              url: `https://timenow-api-dev.geshdo.com/reports/${report.id}`,
              method: 'DELETE',
              headers: {
                "userId": member.userId
              }
            })
          } catch {
            console.error('oops')
          }
        })
      )
    })
  )

  console.log('Step 4 - removing members from team')
  await Promise.all(
    teamMembers.map(async (member) => {
      try {
        await axios.delete(`https://timenow-api-dev.geshdo.com/admin/teams/${mockTeam.id}/members/${member.userId}`)
        console.log(`Removed ${member.firstName} from ${mockTeam.name}`)
      } catch {
        console.error(`Failed to remove ${member.firstName} from ${mockTeam.name}`)
      }
    })
  )
  console.log('Step 5 - delete the team')
  await axios.delete(`https://timenow-api-dev.geshdo.com/admin/teams/${mockTeam.id}`)

  console.log('Step 6 - deleting employees')
  await Promise.all(
    teamMembers.map(async (member) => {
      try {
        await axios.delete(`https://timenow-api-dev.geshdo.com/admin/employees/${member.userId}`)
        console.log(`Deleted: ${member.firstName}`);
      } catch {
        console.error(`Failed to delete: ${member.firstName}`)
      }
    })
  )
  console.log('Step 7 - deleting users')
  await Promise.all(
    teamMembers.map(async (member) => {
      try {
        await axios.delete(`https://timenow-api-dev.geshdo.com/admin/user/${member.userId}`)
        console.log(`Deleted: ${member.firstName}`);
      } catch {
        console.error(`Failed to delete: ${member.firstName}`)
      }
    })
  )

  console.log('Cleanup completed, congratulations, you are now just an ordinary human once again 🤷‍♂️')
};